import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import "../../styles/more-premium.css";

export function MoreSubpage(props: {
  title: string;
  onBack(): void;
  children: ReactNode;
}) {
  return (
    <section className="fr-more-subpage">
      <header className="fr-more-subpage-heading">
        <Button variant="ghost" onClick={props.onBack}>
          ‹ More
        </Button>
        <h1>{props.title}</h1>
      </header>
      <div className="fr-more-subpage-content">{props.children}</div>
    </section>
  );
}
